import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Lock, Route } from 'lucide-react';

const Step = ({ m, last, onOpen }) => {
  const done = m.status === 'completed';
  const current = m.status === 'current';
  const clickable = m.status !== 'locked';
  return (
    <li className="relative flex-1 min-w-[96px]" data-testid={`hc-pathways-step-${m.step}`}>
      {!last && <span className={`absolute top-5 left-1/2 w-full h-1 rounded-full ${done ? 'bg-[#922A8C]' : 'bg-gray-200'}`} />}
      <button onClick={clickable ? () => onOpen(m) : undefined} disabled={!clickable} title={m.title}
        className="relative z-10 flex flex-col items-center w-full text-center group disabled:cursor-not-allowed" data-testid={`hc-pathways-step-btn-${m.step}`}>
        <span className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-transform group-enabled:group-hover:scale-110 ${
          done ? 'bg-[#922A8C] text-white' : current ? 'bg-white text-[#922A8C] ring-4 ring-[#922A8C]' : 'bg-gray-100 text-gray-400'}`}
          data-testid={`hc-pathways-step-status-${m.step}`} data-status={m.status}>
          {done ? <Check className="w-5 h-5" /> : m.status === 'locked' ? <Lock className="w-4 h-4" /> : m.step}
        </span>
        <span className={`mt-2 text-xs font-bold ${current ? 'text-[#922A8C]' : 'text-[#363636]'}`}>Module {m.step}</span>
        <span className="text-[11px] text-gray-500 leading-tight line-clamp-2 px-1">{m.title.replace(/^M\d+:\s*/, '')}</span>
        {current && <span className="mt-1 text-[11px] font-semibold text-[#922A8C]">{m.progress}% done</span>}
      </button>
    </li>
  );
};

export const PathwaysTracker = ({ modules }) => {
  const navigate = useNavigate();
  if (!modules?.length) return null;
  const done = modules.filter((m) => m.status === 'completed').length;
  return (
    <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6" data-testid="hc-pathways-tracker">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-5">
        <h2 className="text-base md:text-lg font-bold text-[#363636] flex items-center gap-2"><Route className="w-5 h-5 text-[#922A8C]" />Your Pathways to Employability Journey</h2>
        <span className="text-sm font-semibold text-gray-600" data-testid="hc-pathways-count">{done} of {modules.length} modules complete</span>
      </div>
      <ol className="flex overflow-x-auto pb-1">
        {modules.map((m, i) => <Step key={m.step} m={m} last={i === modules.length - 1} onOpen={(x) => navigate(`/helpconnect/courses/${x.course_id}`)} />)}
      </ol>
    </section>
  );
};
